// How many texts an SMS goes out as. Mirrors server/services/smsService
// splitSmsMessage: VoIP.ms rejects a body over 160 characters, so a longer
// text is sent as numbered parts ("(1/2) …"), split on word boundaries.
export const SMS_SEGMENT_LIMIT = 160;
const PART_PREFIX_RESERVE = 8; // room for "(10/12) "

export function smsPartCount(message) {
  const text = String(message || '').trim();
  if (!text) return 0;
  if (text.length <= SMS_SEGMENT_LIMIT) return 1;
  const max = SMS_SEGMENT_LIMIT - PART_PREFIX_RESERVE;
  let parts = 0;
  let current = '';
  for (let word of text.split(/\s+/)) {
    // A word longer than a whole part (a long link) is cut.
    while (word.length > max) {
      if (current) { parts += 1; current = ''; }
      parts += 1;
      word = word.slice(max);
    }
    if (!word) continue;
    const candidate = current ? `${current} ${word}` : word;
    if (candidate.length > max) { parts += 1; current = word; } else current = candidate;
  }
  if (current) parts += 1;
  return parts;
}
